import React from "react";
import SuperAdminMainDashboard from "../../../Components/GNA/SuperAdmin/SuperAdminMainDashboard";

const Page_Super_Admin_dash = () => {
  return <SuperAdminMainDashboard />;
};

export default Page_Super_Admin_dash;
